<template>
    <div class="staff">
<!--      <el-card>-->
<!--        <el-breadcrumb separator="/">-->
<!--          <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--          <el-breadcrumb-item>数据统计</el-breadcrumb-item>-->
<!--          <el-breadcrumb-item>供应商</el-breadcrumb-item>-->
<!--        </el-breadcrumb>-->
<!--      </el-card>-->
      <main class="content">
        <div ref="tablePosition"></div>
        <el-card>
          <el-table
            size="mini" stripe
            :data="tableData"
            v-loading="loading"
            :height="tableConfig.height"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="供应商">
            </el-table-column>
            <el-table-column
              prop="product"
              label="中标率">
              <template slot-scope="scope">
                {{scope.row.biddingRate}}% ({{scope.row.bidding}}/{{scope.row.inquiry}})
              </template>
            </el-table-column>
            <el-table-column
              prop="supplierResponseTime"
              label="响应时效">
              <template slot-scope="scope">
                {{scope.row.supplierResponseTime}}天
              </template>
            </el-table-column>
            <el-table-column
              prop="deliveryCycle"
              label="发货周期">
              <template slot-scope="scope">
                {{scope.row.deliveryCycle}}天
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250" align="right">
                <template slot="header">
                    <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">刷新</el-button>
                </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;padding-top: 20px">
            <el-pagination
                background
                layout="sizes,prev, pager, next"
                :page-sizes="[10, 20, 50, 100]"
                v-if="total>0"
                :total="total"
                :page-size="pageSize"
                @size-change="handleSizeChange"
                @current-change="onPageChange"
                :current-page="currentPage"
                @prev-click="onPageChange"
                @next-click="onPageChange">
            </el-pagination>
          </div>
        </el-card>
      </main>
    </div>
  </template>
  <script>
  const HEIGHT_OFFSET = 20;
  export default {
      data() {
          return {
              pageLoading: undefined,
              tableConfig: {
                height: 0,
              },
              loading: false,
              total: 0,
              pageSize: 10,
              currentPage: 1,
              tableData: [],
          }
      },
      methods: {
          onSearch() {
              this.loading = true;
              let that = this
              this.$axios.post("/admin/statistics/supplier",{
                  cond: this.searchForm,
                  page: this.currentPage - 1,size:this.pageSize
              }).then(function(response) {
                  let resp = response.data;
                  if(resp.header.status == 0) {
                    that.loading = false;
                    that.tableData = resp.data.content;
                    that.total = resp.data.totalElements;
                  }
              }).catch(function() {
                that.loading = false;
              });
          },
        handleSizeChange(pageSize){
          this.pageSize = pageSize;
          this.onSearch();
        },
        onPageChange(currentPage) {
          this.currentPage = currentPage;
          this.onSearch();
        },
        setTableHeight() {
          const tablePosition = this.$refs['tablePosition'];
          const {top} = tablePosition.getBoundingClientRect();
          this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
      },
      created() {
        this.onSearch();
        window.addEventListener("resize", this.setTableHeight);
      },
      mounted() {
        this.pageLoading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          this.setTableHeight();
          this.pageLoading.close();
          this.pageLoading = undefined;
        }, 500);
      },
      beforeDestroy() {
        if(this.pageLoading){
          this.pageLoading.close();
          this.pageLoading = undefined;
        }
      },
      destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
      }
  }
  </script>